import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { endPoints } from "../../../constant/Environment";
import { deleteData, getAllFilterData } from "../../../Utility/API";
import { Form, Button } from "react-bootstrap";
import TransferSearch from "../../../components/FilterComponent/TransferSearch";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Actions } from "../../../redux/Actions/Actions";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
const TransferDetail = () => {
  const [pending, setPending] = useState(true);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoadinig] = useState(false);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  

    const filteredItems = {
    name: "",
    platform:"1",
    status:"",
    regdate: "",
    state: "",
    city: "",
    accounNumber:""
  };
  function getNumberOfPages(rowCount, rowsPerPage) {
    return Math.ceil(rowCount / rowsPerPage);
  }
  
  function toPages(pages) {
    const results = [];
    for (let i = 1; i <= pages; i++) {
      results.push(i);
    }
  
    return results;
  }
  const columns = [
    {
      name: "Account Designation",
      selector: (row) => row.account_Designation,
      sortable: true,
    },
    {
      name: "Transaction Number",
      selector: (row) => row.transaction_Number,
      sortable: true,
    },
    {
      name: "Account Number",
      selector: (row) => row.account_Number,
      sortable: true,
    },
    {
      name: "Date Time",
      selector: (row) => row.date_Time,
      sortable: true,
    },
    {
      name: "Payment Method",
      selector: (row) => row.payment_Method,
      sortable: true,
    },
    {
      name: "Deposit Amount",
      selector: (row) => row.deposit_Amount,
      sortable: true,
    },
    {
      name: "Deposit Method",
      selector: (row) => row.deposit_Method,
      sortable: true,
    },
    {
      name: "Platform",
      selector: (row) => row.platform,
      sortable: true,
    },
    {
      name: "Withdrawal Amount",
      selector: (row) => row.withdrawal_Amount,
      sortable: true,
    },
    {
      name: "Withdrawal Method",
      selector: (row) => row.withdrawal_Method,
      sortable: true,
    }
  ];

  // RDT exposes the following internal pagination properties
const BootyPagination = ({
  rowsPerPage,
  rowCount,
  onChangePage,
  onChangeRowsPerPage, // available but not used here
  currentPage
}) => {
  const handleBackButtonClick = () => {
    onChangePage(currentPage - 1);
  };

  const handleNextButtonClick = () => {
    onChangePage(currentPage + 1);
  };

  const handlePageNumber = (e) => {
    onChangePage(Number(e.target.value));
  };

  const pages = getNumberOfPages(rowCount, rowsPerPage);
  const pageItems = toPages(pages);
  const nextDisabled = currentPage === pageItems.length;
  const previosDisabled = currentPage === 1;

  return (
    <nav>
      <ul className="pagination">
        <li className="page-item">
          <button
            className="page-link"
            onClick={handleBackButtonClick}
            disabled={previosDisabled}
            aria-disabled={previosDisabled}
            aria-label="previous page"
          >
            Previous
          </button>
        </li>
        {pageItems.map((page) => {
          
          const className =
            page === currentPage ? "page-item active" : "page-item";

          return (
            <li key={page} className={className}>
              <button
                className="page-link"
                onClick={handlePageNumber}
                value={page}
              >
                {page}
              </button>
            </li>
          );
        })}
        <li className="page-item">
          <button
            className="page-link"
            onClick={handleNextButtonClick}
            disabled={nextDisabled}
            aria-disabled={nextDisabled}
            aria-label="next page"
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};


 


  useEffect(() => {
    fetchUserData(filteredItems);
  }, []);

  const fetchUserData = async (data) => {
    let url = `${endPoints.api.TRANSFER_DETAIL_LIST}`;
    await getAllFilterData(url,data)
      .then((response) => {
        console.log("data", response.status);
        if (response.status === "success") {
          setRows(response.data);
          setPending(false);
        } else {
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const create = () => {
    navigate("/CreateUser");
  }
  const searchList = (filterObj) => {
    fetchUserData(filterObj);
  }
  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{padding:'0px'}}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="mb-2">Transfer Detail</h2>
                </div>
              </div>
              <div
                className="row"
                style={{ padding: "5px 0px 20px 0px" }}
              >
                 <div className="col-md-12">
                <TransferSearch searchList={searchList}></TransferSearch>
                </div>
              
                </div>
                <div className="container-fluid table-custom">
              <div
                className="row"
                style={{  padding: "5px 0px 20px 0px" }}
              >
               
               <div className="col-md-12">
                <DataTable
          title=""
          columns={columns}
          data={rows}
          defaultSortFieldID={1}
          pagination
          paginationComponent={BootyPagination}
          paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
          // subHeader
          // subHeaderComponent={subHeaderComponentMemo}
        />

               </div>
               </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransferDetail;
